import { addFollowed, removeFollowed } from './_idMap/actions';
import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';
import { postFollow, postUnfollow } from '@api/followers';

export const postCoreFollowSlice = createPostAsyncSlice({
	httpSagaOptions: {
		preRequestActionCreators: [ (data) => addFollowed(data.sonarObjectIds) ]
	},
	name: 'CoreFollow',
	receive: false,
	request: true,
	requestHandler: postFollow,
	yieldType: SagaYieldType.Latest
});

export const postCoreUnfollowSlice = createPostAsyncSlice({
	httpSagaOptions: {
		preRequestActionCreators: [ (data) => removeFollowed(data.sonarObjectIds) ]
	},
	name: 'CoreUnfollow',
	receive: false,
	request: true,
	requestHandler: postUnfollow,
	yieldType: SagaYieldType.Latest
});
